<template>
  <div id="AddTimeline">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="timelineText">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 md6">
            <v-autocomplete
              v-model="accountData" 
              @keyup="searchFamilies($event)"
              @input="selectAccount"
              :items="accountList" 
              item-text="name"
              item-value="id"
              label="Associated Account"
              :rules="[rules.toRule]"
              hide-no-data
              return-object
              clearable
              placeholder="Search by Name / Nickname / Agency"
              hint="Type atleast 3 characters to search"
              class="required pr-4 pl-4">
            </v-autocomplete>
        </v-flex>

        <v-flex class="xs12 md6">
          <v-select
            :items="Task"
            v-model="taskSelected" 
            @change="changedData"
            :disabled="Task.length === 0"
            item-text="name"
            item-value="id"
            clearable
            placeholder="Select a Task"
            label="Associated Task"
            class="required pr-4 pl-4"
          ></v-select>
        </v-flex>
      </v-layout>
      
      <v-layout>
        <v-flex class="xs12 pr-4 pl-4 required-label">
          <label>Select a status</label>
          <v-radio-group v-model="timelineStatus" row pl-1>
            <v-radio color="red" label="Open" value="Open"></v-radio>
            <v-radio color="yellow" label="In-Progress" value="In-Progress"></v-radio>
            <v-radio color="green" label="Closed" value="Closed"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div id="pageEditor">
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <quill-editor
                    :content="content"
                    :options="editorOption"
                    @input="changedData"
                    v-model="timelineText"
                  >
                  </quill-editor>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store */
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import { create, getCollection } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';

export default {
  name: 'Timeline',
  components: {
    quillEditor
  },
  data: () => ({
    content: '',
    editorOption: {
      placeholder: 'Add Timeline description here...',
    },
    query: {
      family: ''
    },
    accountData: '',
    accountList: [],
    selectedData: false,
    timelineText: '',
    rules: {
      subjectRule: (v) => !!v || 'Please enter subject',
      toRule: (v) => !!v || 'Please select recipient',
      contentRule: (v) => !!v || 'Please enter reply',
    },
    taskSelected: null,
    timelineStatus: 'Open'
  }),
  computed: {
    ...mapGetters(['Agency', 'Task']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    Timeline: {
      get () {
        return store.state.Timeline;
      },
      set (value) {
        store.commit('setTimeline', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.getTimeLines();
    // this.initializeAgencyList();
    // this.getTasks();
  },
  methods: {
    async getTimeLines () {
      if (!this.Timeline.length) {
        let entity = `Timeline`;
        let sessionUser = session.getSession();
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Timeline = data;
          }
        }
      }
    },
    async getTasks (membership, accountID) {
      // if (!this.Task.length) {
      let entity = `Task`;
      let where = { membership: membership };
      let { error, data } = await getCollection(entity, true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          store.commit('setTask', data);
        }
      }
      // }
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/timelines' });
    },
    async searchFamilies (e) {
      this.accountList = [];
      this.accountData = '';
      this.query.family = e.target.value;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2)) {
        let where = { };
        if (this.query.family && this.query.family.length > 2) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.accountList = data;
            console.log('this.accountList', this.accountList);
          }
        }
      }
    },
    changedData (e) {
      console.log('changedData', e);
      this.selectedData = e !== undefined ? true : false;
    },
    selectAccount (e) {
      if (e) {
        this.getTasks(this.accountData.membership, this.accountData);
      } else {
        this.taskSelected = '';
        store.commit('setTask', []);
      }
      console.log('selectAccount', e, this.accountData);
    },
    hideButtons () {
      window.getApp.$emit('pageSubHeader', '');
      this.selectedData = false;
      this.$router.push({ path: '/timelines' });
    },
    async save () {
      this.selectedData = false;
      if (this.timelineText === '' || this.timelineText === '<p> </p>' || this.taskSelected === null || this.taskSelected === undefined) {
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add content before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      } else {
        let TimelineObj = {
          text: session.getSession().user.human.name + ' Created a new Timeline',
          description: this.timelineText,
          account: this.accountData.id,
          task: this.taskSelected,
          status: this.timelineStatus
        };
        if (session.getSession().adminUser) {
          TimelineObj.account = session.getSession().user.human.account.id;
        }
        console.log('TimelineObj', TimelineObj);
        let { error, data } = await create('Timeline', TimelineObj);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.Timeline.unshift(data);
          swal.fire({
            type: 'success',
            title: 'Timeline added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/admin/timelines' });
            }
          });
        }
      }
    },
  }
};
</script>

<style scoped>
.required-label {
    color: rgba(0,0,0,0.54);
    font-size: 12px;
    margin-left: 10px;
}
.required-label::before {
    content: "*";
    color: red;
    padding-right:3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Timelines/admin_add.vue